module.exports = __webpack_public_path__ + "static/media/94.a5f8bac6.png";